export default __webpack_public_path__ + "static/media/donateheader.15a41863.png";